import React from "react";
import { connect } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import Badge from "@mui/material/Badge";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const useStyles = makeStyles((theme) => ({
  badge: {
    fontSize: "12px",
    borderRadius: "50%",
  },
}));

const mapStateToProps = (state) => {
  const loggedUserId = state.loggeduser.LoggedUser.id;
  const unpublishedDays = state.unpublisheddays.UnpublishedDays;
  return {
    loggedUserId,
    unpublishedDays,
  };
};

function UnpublishedDaysBadge(props) {
  const classes = useStyles()
  let numUnpublished = 0;
  if (props.unpublishedDays.length > 0) {
    numUnpublished = props.unpublishedDays.reduce(function (prev, act) {
      return prev + parseFloat(act.numDays);
    }, 0);
  }

  return (
    <Badge
      color="error"
      showZero={false}
      badgeContent={numUnpublished}
      classes={{
        badge: classes.badge,
      }}
    >
      <VisibilityOffIcon />
    </Badge>
  );
}

export default connect(mapStateToProps, null)(UnpublishedDaysBadge);
